import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { ClippingPlatformState } from 'store/clippingPlatformState';
import { createModalCloseAction } from 'actions/modalActions';
import { Modal } from './Modal';
import { ModalContainerProps } from './Modal.types';

export const mapStateToProps = (state: ClippingPlatformState, ownProps: ModalContainerProps) => {
  const modal = state.appStatus.modals[ownProps.id];
  const open = modal ? modal.open : false;
  const props = modal ? modal.props : {};

  return {
    open,
    ...props,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch, { id }: ModalContainerProps) => ({
  close: () => dispatch(createModalCloseAction(id as any)),
  dispatch,
});

export const ModalContainer = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  ModalContainerProps,
  ClippingPlatformState
>(
  mapStateToProps,
  mapDispatchToProps,
)(Modal);
